import React, { memo } from 'react';
import { reduxForm } from 'redux-form';
import { AudienceInput } from '@common/components/form/audience';
import { DialogWrapper } from '@common/components/modal/dialog-wrapper';
import './audience-modal.scss';

const AUDIENCE_MODAL = 'audience-modal';

const BaseAudienceModal = memo(({
  onSubmit,
  show,
  onShow,
  onHide,
  handleSubmit,
  children,
  title,
  submitting,
  enabledFilters
}: any) => {
  return (
    <DialogWrapper
      trigger={children}
      show={show}
      onHide={onHide}
      onShow={onShow}
      size="large"
      title={title}
      onConfirm={handleSubmit(onSubmit)}
      confirmButtonForm={AUDIENCE_MODAL}
      confirmButtonType="submit"
      confirmButtonLoading={!!submitting}
      content={
        <form
          id={AUDIENCE_MODAL}
          className="audienceModalForm"
          onSubmit={handleSubmit(onSubmit)}
        >
          <AudienceInput
            name="audience"
            enabledFilters={enabledFilters}
          />
        </form>
      }
    />
  );
});

const form = reduxForm({ form: AUDIENCE_MODAL });
const AudienceModal = form(BaseAudienceModal);

export default AudienceModal;
